import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "msg-base" }
const _hoisted_2 = {
  key: 0,
  class: "body-img"
}

import MsgMineMenu from "@/views/ChatMessage/MsgMineMenu.vue";
import { isCompactMode } from "@/data/pubilc";
import { toRefs } from "vue";
import { ElMessage } from "element-plus";
import Clipboard from "clipboard";
import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";


export default /*@__PURE__*/_defineComponent({
  __name: 'MsgMine',
  props: {
  msgObj: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { msgObj } = toRefs(props);

const menuAction = (index: number) => {
  //0 copy 1 edit
  if (index === 0) {
    ElMessage.success("已复制");
    Clipboard.copy(msgObj.value.content);
  } else {
    //
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["body", { 'compact-body': _unref(isCompactMode) }])
    }, [
      _createVNode(_component_el_popover, {
        placement: "left-start",
        width: 80,
        trigger: "hover",
        "show-arrow": false,
        "popper-class": "my-popper"
      }, {
        reference: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(msgObj).content), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(MsgMineMenu, { onMenuAction: menuAction })
        ]),
        _: 1
      }),
      (_unref(msgObj).url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_image, {
              style: {"width":"170px","height":"auto"},
              src: _unref(msgObj).url,
              "zoom-rate": 1.2,
              "max-scale": 7,
              "min-scale": 0.2,
              "preview-src-list": [_unref(msgObj).url],
              "show-progress": "",
              "initial-index": 4,
              fit: "cover"
            }, null, 8, ["src", "preview-src-list"])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})